/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
import Member from '@linc-technologies/linced-common/models/groups/member';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type Person from '@linc-technologies/linced-common/models/person';

// Proto: groups.Member.
export default class GroupsMember extends Member {
  declare [Type]: 'groups/member';

  // A plain getter, not the cached computed of the common fragment. Callers
  // read it after they load more person records.
  get person() {
    if (!this.personId) {
      return null;
    }
    return this.store.peekRecord<Person>('person', this.personId);
  }

  // Special case used by Events
  @alias('permissionReply.intentionToAttend')
  declare intentionToAttend: unknown;

  @computed('intentionToAttend')
  get intentionToAttendString() {
    if (this.intentionToAttend === true) {
      return 'Yes';
    }
    if (this.intentionToAttend === false) {
      return 'No';
    }
    return '';
  }
}
